import { EventSeriesOption } from '../hooks/useEvent/useEventTypes';
/**
 * Decision logic for canceling an event **as the space** via
 * `DELETE /v2/spaces/{space_id}/events/{event_id}[/series[/this-and-following]]`.
 *
 * Rules:
 * - Non-recurring events can be canceled as the space on any provider.
 * - Recurring events on Google can be canceled as a single instance or as
 *   the entire series — never this-and-following.
 * - Recurring events on any other provider (Microsoft, etc.) support every
 *   option: single instance, this-and-following, and the entire series.
 *
 * TODO a further restriction — non-organizers cannot
 * delete events whose organizer is on Microsoft — was explicitly deferred.
 */
export var resolveAsSpaceCancelOptions = function (_a) {
    var isRecurring = _a.isRecurring, remoteType = _a.remoteType;
    if (!isRecurring) {
        return [EventSeriesOption.THIS_EVENT];
    }
    if (remoteType === null || remoteType === void 0 ? void 0 : remoteType.includes('google')) {
        return [EventSeriesOption.THIS_EVENT, EventSeriesOption.ALL_EVENTS];
    }
    return [
        EventSeriesOption.THIS_EVENT,
        EventSeriesOption.THIS_AND_FOLLOWING_EVENTS,
        EventSeriesOption.ALL_EVENTS,
    ];
};
/**
 * Path for the cancel-as-space endpoint, relative to `baseApiUrl`.
 * `eventId` must be a Robin event ID; the series variants are passed an
 * instance's ID and the backend resolves the series from it.
 */
export var buildCancelEventAsSpacePath = function (spaceId, eventId, option) {
    var suffix = option === EventSeriesOption.ALL_EVENTS
        ? '/series'
        : option === EventSeriesOption.THIS_AND_FOLLOWING_EVENTS
            ? '/series/this-and-following'
            : '';
    return "/v2/spaces/".concat(spaceId, "/events/").concat(eventId).concat(suffix);
};
